function o() {
  return "crypto" in window && window?.crypto?.randomUUID != null ? window.crypto.randomUUID() : "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(n) {
    const x = Math.random() * 16 | 0;
    return (n === "x" ? x : x & 3 | 8).toString(16);
  });
}
export {
  o as randomUUID
};
